import { useCallback, useEffect, useState } from "react";
import {
    AssignInquiry,
    GetUploadBatch,
    uploadCsv,
} from "../../services/inquiryService";
import { GetUserDetailsByRoleId } from "../../services/userService";
import CommonDropdown from "../../common/CommonDropdown";

const AddInquary = () => {
    const uploadUserId = Number(localStorage.getItem("userid"));
    const userPermissionRoleId = Number(
        localStorage.getItem("userPermissionRoleId")
    );

    const [file, setFile] = useState(null);

    const [uploadLoading, setUploadLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);

    const [uploadBatchData, setUploadBatchData] = useState([]);
    const [selectedBatch, setSelectedBatch] = useState("");

    const [users, setUsers] = useState([]);

    const [uploadId, setUploadId] = useState("");
    const [totalRecord, setTotalRecord] = useState("");

    const [errors, setErrors] = useState({});

    //------------------------------------------
    // Load Initial Data
    //------------------------------------------
    const loadData = useCallback(async () => {
        try {
            setPageLoading(true);

            const [batchResponse, userResponse] = await Promise.all([
                GetUploadBatch(),
                GetUserDetailsByRoleId(userPermissionRoleId),
            ]);

            if (batchResponse?.success) {
                const batches = batchResponse.data.map(item => ({
                    id: item.id,
                    name: `Batch ${item.id} (${item.totalRecords} Records)`,
                    totalRecords: item.totalRecords,
                }));

                setUploadBatchData(batches);
                //setUploadBatchData(batchResponse.data || []);
            }

            if (userResponse?.success) {
                setUsers(
                    (userResponse.data || []).map(user => ({
                        ...user,
                        assignRecord: 0,
                    }))
                );
            }
        } catch (error) {
            setErrors({
                form: error.message || "Something went wrong",
            });
        } finally {
            setPageLoading(false);
        }
    }, [userPermissionRoleId]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    //------------------------------------------
    // File Change
    //------------------------------------------
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];

        if (!selectedFile) return;

        if (
            !selectedFile.name
                .toLowerCase()
                .endsWith(".csv")
        ) {
            alert("Please select CSV file only.");
            e.target.value = "";
            return;
        }

        setFile(selectedFile);
    };

    //------------------------------------------
    // Upload
    //------------------------------------------
    const handleUpload = async () => {
        if (!file) {
            alert("Please select CSV file.");
            return;
        }

        const formData = new FormData();

        formData.append("File", file);
        formData.append(
            "UploadUserId",
            uploadUserId.toString()
        );

        try {
            setUploadLoading(true);

            const response = await uploadCsv(formData);

            if (
                response?.success &&
                response?.statusCode === 200
            ) {
                setUploadId(response.data.uploadId);
                setTotalRecord(response.data.totalRecords);

                alert(response.message);

                setFile(null);
                await loadData(); // Refresh dropdown
                setSelectedBatch(response.data.uploadId); // Select newly uploaded batch
    autoAssignRecords(response.data.totalRecords);
            } else {
                alert(response.message);
            }
        } catch (error) {
            console.log(error);

            alert(
                error.response?.data?.message ||
                "Upload failed."
            );
        } finally {
            setUploadLoading(false);
        }
    };

    //------------------------------------------
    // Assign Record Change
    //------------------------------------------
    const handleAssignChange = (index, value) => {
        const updatedUsers = [...users];

        updatedUsers[index].assignRecord =
            value === "" ? "" : Number(value);

        setUsers(updatedUsers);
    };

    //------------------------------------------
    // Calculate Assigned Total
    //------------------------------------------
    const assignedTotal = users.reduce(
        (sum, item) => sum + Number(item.assignRecord || 0),
        0
    );
    const autoAssignRecords = (totalRecords) => {
        if (!users.length) return;

        const total = Number(totalRecords);
        const userCount = users.length;

        const perUser = Math.floor(total / userCount);
        const remainder = total % userCount;

        const updatedUsers = users.map((user, index) => ({
            ...user,
            assignRecord: perUser + (index < remainder ? 1 : 0),
        }));

        setUsers(updatedUsers);
    };
    const handleSave = async () => {
        if (!selectedBatch) {
            alert("Please select batch.");
            return;
        }

        if (assignedTotal !== Number(totalRecord)) {
            alert("Assigned records must equal Total Records.");
            return;
        }

        const payload = {
            uploadId: Number(selectedBatch),
            assignUsers: users.map((user) => ({
                userId: user.id,
                count: Number(user.assignRecord),
            })),
        };

        console.log(payload);

        try {
            const response = await AssignInquiry(payload);

            if (response.success) {
                alert(response.message);

                // Reset Form
                setSelectedBatch("");
                setUploadId("");
                setTotalRecord("");
                setFile(null);

                setUsers((prev) =>
                    prev.map((u) => ({
                        ...u,
                        count: 0,
                    }))
                );

                loadData();
            } else {
                alert(response.message);
            }
        } catch (err) {
            console.log(err);
            alert("Something went wrong.");
        }
    };
    return (
        <div className="container py-3">

            <h4 className="mb-4">
                CSV File Upload
            </h4>

            {errors.form && (
                <div className="alert alert-danger">
                    {errors.form}
                </div>
            )}

            <div className="row mb-4">
                <div className="col-md-6">
                    <input
                        type="file"
                        accept=".csv"
                        className="form-control"
                        onChange={handleFileChange}
                    />
                </div>

                <div className="col-md-3">
                    <button
                        className="btn btn-primary w-100"
                        onClick={handleUpload}
                        disabled={uploadLoading}
                    >
                        {uploadLoading
                            ? "Uploading..."
                            : "Upload"}
                    </button>
                </div>
            </div>

            <div className="row mb-4">

                <div className="col-md-3">
                    <strong>Upload ID :</strong>{" "}
                    {uploadId}
                </div>

                <div className="col-md-3">
                    <strong>Total Records :</strong>{" "}
                    {totalRecord}
                </div>

                <div className="col-md-3">
                    <strong>Assigned :</strong>{" "}
                    {assignedTotal}
                </div>

                <div className="col-md-3">
                    <strong>Remaining :</strong>{" "}
                    {Math.max(
                        totalRecord - assignedTotal,
                        0
                    )}
                </div>
            </div>

            <div className="mb-4">

                <CommonDropdown
                    label="Select Batch"
                    options={uploadBatchData}
                    value={selectedBatch}
                    onChange={(value) => {
                        setSelectedBatch(value);

                        const batch = uploadBatchData.find(
                            (item) => Number(item.id) === Number(value)
                        );

                        if (batch) {
                            setTotalRecord(batch.totalRecords);
                            autoAssignRecords(batch.totalRecords);
                        }
                    }}
                    labelField="name"
                    valueField="id"
                    placeholder="Select Batch"
                />

            </div>

            <div className="table-responsive">

                <table className="table table-bordered table-hover">

                    <thead className="table-dark">

                        <tr>
                            <th style={{ width: 60 }}>#</th>
                            <th>User</th>
                            <th width="180">
                                Assign Record
                            </th>
                        </tr>

                    </thead>

                    <tbody>

                        {pageLoading ? (
                            <tr>
                                <td
                                    colSpan={3}
                                    className="text-center"
                                >
                                    Loading...
                                </td>
                            </tr>
                        ) : users.length > 0 ? (
                            users.map(
                                (user, index) => (
                                    <tr
                                        key={user.id}
                                    >
                                        <td>
                                            {index + 1}
                                        </td>

                                        <td>
                                            {
                                                user.userName
                                            }
                                        </td>

                                        <td>
                                            <input
                                                type="number"
                                                min={0}
                                                className="form-control"
                                                value={
                                                    user.assignRecord
                                                }
                                                onChange={(
                                                    e
                                                ) =>
                                                    handleAssignChange(
                                                        index,
                                                        e
                                                            .target
                                                            .value
                                                    )
                                                }
                                            />
                                        </td>
                                    </tr>
                                )
                            )
                        ) : (
                            <tr>
                                <td
                                    colSpan={3}
                                    className="text-center"
                                >
                                    No Data Found
                                </td>
                            </tr>
                        )}

                    </tbody>

                </table>

            </div>
            <div className="text-end mt-3">
                <button
                    className="btn btn-success"
                    onClick={handleSave}
                    disabled={
                        users.length === 0 ||
                        assignedTotal !== Number(totalRecord)
                    }
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default AddInquary;